<template>
   <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="货源搜索列表" style="height:auto" >
      <el-form :inline="true" :model="productForm" class="demo-form-inline">
        <el-form-item label="产品型号">
          <el-input v-model.trim="productForm.manufacturerNumber" placeholder="产品型号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        size = "small"
        border>
        <el-table-column
          prop="manufacturerNumber"
          show-overflow-tooltip
          label="产品型号">
        </el-table-column>
        <el-table-column
          prop="price"
          label="价格">
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="联系电话">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址">
        </el-table-column>
        <el-table-column
          prop="createDate"
          show-overflow-tooltip
          label="时间">
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      productForm: {
        manufacturerNumber: '',
        token: this.store.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  methods: {
    getProductData: function() {
      this.optionItem = this.store.extend(this.productForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/purchase/search', 
        this.optionItem, res => 
        {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getProductData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getProductData()
    }
  },
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-input--suffix .el-input__inner {
  padding-right: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/purchase/productPurchaseList.vue